import { Link } from 'react-router';
import { useAdminOrders } from '../../api/admin-queries.js';
import { formatDateTime, formatPrice, lotHref, ORDER_STATUS_LABELS } from '../../lib/format.js';
import { Badge } from '../badge.js';
import { EmptyState } from '../empty-state.js';
import { ErrorState } from '../error-state.js';

export function OrdersTable() {
  const orders = useAdminOrders();
  if (orders.isError) return <ErrorState message="No pudimos cargar los pedidos." />;
  return (
    <section aria-labelledby="orders-title" className="flex flex-col gap-3">
      <h2 id="orders-title" className="text-xl font-bold">
        Pedidos del portal
      </h2>
      {orders.data === undefined && <p aria-live="polite">Cargando pedidos…</p>}
      {orders.data?.length === 0 && <EmptyState message="Todavía no hay pedidos." />}
      {orders.data !== undefined && orders.data.length > 0 && (
        <div className="overflow-x-auto rounded-card border border-border bg-card">
          <table className="w-full min-w-[48rem] text-left text-sm">
            <thead className="bg-muted text-muted-foreground">
              <tr>
                <th scope="col" className="px-4 py-3 font-medium">
                  Fecha
                </th>
                <th scope="col" className="px-4 py-3 font-medium">
                  Comprador
                </th>
                <th scope="col" className="px-4 py-3 font-medium">
                  Kits
                </th>
                <th scope="col" className="px-4 py-3 font-medium">
                  Estado
                </th>
                <th scope="col" className="px-4 py-3 text-right font-medium">
                  Total
                </th>
                <th scope="col" className="px-4 py-3 font-medium">
                  Lotes entregados
                </th>
              </tr>
            </thead>
            <tbody>
              {orders.data.map((order) => (
                <tr key={order.publicId} className="border-t border-border align-top">
                  <td className="px-4 py-3 whitespace-nowrap">{formatDateTime(order.createdAt)}</td>
                  <td className="px-4 py-3">
                    {order.buyer.name}
                    {order.buyer.email !== null && (
                      <span className="block text-muted-foreground">{order.buyer.email}</span>
                    )}
                  </td>
                  <td className="px-4 py-3">
                    {order.lines.map((line) => `${String(line.quantity)} × ${line.sku}`).join(', ')}
                  </td>
                  <td className="px-4 py-3">
                    <Badge tone={order.status === 'PAID' ? 'success' : 'neutral'}>
                      {ORDER_STATUS_LABELS[order.status] ?? order.status}
                    </Badge>
                  </td>
                  <td className="px-4 py-3 text-right tabular-nums">{formatPrice(order.total)}</td>
                  <td className="px-4 py-3">
                    {order.lots.length === 0 ? (
                      <span className="text-muted-foreground">—</span>
                    ) : (
                      <ul className="flex flex-col gap-1">
                        {order.lots.map((lot) => (
                          <li key={lot.lotId}>
                            <Link
                              to={lotHref(lot.lotId)}
                              className="text-accent underline-offset-2 hover:underline"
                            >
                              {lot.quantity} × {lot.lotId}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
